<template>
  <div class="platformMerchant_Box">
    <div class="platformMerchant_Head">
      <el-form ref="formInline" :model="formInline" inline>
        <el-form-item prop="timeDate">
          <el-date-picker
            v-model="formInline.timeDate"
             size="small"
            :editable="false"
            :clearable="false"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="timeDateChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="微信收款方式" prop="mchType">
          <el-select v-model="formInline.mchType" clearable size="small">
            <el-option value="" label="全部"></el-option>
            <el-option :value="1" label="微信"></el-option>
            <el-option :value="3" label="企业微信"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台商户" prop="mchBody">
          <el-input
           size="small"
            placeholder="请输入平台商户"
            v-model="formInline.mchBody"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item class="head_Box">
          <el-button type="primary" size="small" @click="timeDateChange(formInline.timeDate)">查询</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
          <el-button type="primary" size="small" @click="platformMerchantExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="platformMerchant_Body">
      <el-table
        border
        stripe
        v-loading="loading"
        :data="data"
        style="width: 100%"
      >
        <el-table-column
          prop="mchBody"
          label="平台商户"
          minWidth="270"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.mchBody || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="mchType"
          label="支付方式"
          minWidth="200"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag v-if="row.mchType === 1" type="success">微信</el-tag>
            <el-tag v-else-if="row.mchType === 2">支付宝</el-tag>
            <el-tag v-else-if="row.mchType === 3">企业微信</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="incomeAmount"
          label="收入（元）"
          minWidth="220"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.incomeAmount || 0 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="refundAmount"
          label="退款（元）"
          minWidth="200"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.refundAmount || 0 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="serviceCharge"
          label="手续费（元）"
          minWidth="220"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.serviceCharge || 0 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="accountBalance"
          label="余额（元）"
          minWidth="220"
          align="center"
        >
          <template slot="header">
            日终余额（元）
            <el-tooltip class="item" effect="dark" content="支付宝统计的为日终余额，微信统计的为单日入账金额（单日入账金额=支付结算金额-退款结算金额-手续费）" placement="bottom">
              <i style="cursor: pointer;" class="el-icon-question"></i>
            </el-tooltip>
          </template>
          <template slot-scope="{ row }">
            <span v-if="formInline.timeDate[0] && formInline.timeDate[1] && formInline.timeDate[0].split(' ')[0] === formInline.timeDate[1].split(' ')[0]">{{ row.accountBalance || 0 }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <my-pagination
      :page-info="pageInfo"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
    />

    <!-- 导出 -->
    <file-export ref="FileExport"></file-export>
  </div>
</template>

<script>
import { getListPageByMchBody } from "@/api/accountChecking.js";
import myPagination from "@/components/myPagination.vue";
import FileExport from "@/components/FileExport";
import { clone } from "@/utils/handle.js";
export default {
  components: { myPagination, FileExport },
  data() {
    return {
      loading: false,
      data: [],
      formInline: {
        timeDate: [],
        mchType: '',
        mchBody: ''
      },
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      pickerOptions: {
        disabledDate(time) {
          const baseURL = process.env.NODE_ENV === 'development' ? '2022-3-20 00:00:00' : '2022-3-28 00:00:00'
          return time.getTime() < new Date('2022-1-1 00:00:00').getTime();
        }
      },
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let date = new Date().getTime() - 86400000;
      let year = new Date(date).getFullYear();
      let m = new Date(date).getMonth() + 1;
      let d = new Date(date).getDate();
      let yesterday = `${year}-${m}-${d}`;
      this.$set(this.formInline, "timeDate", [yesterday, yesterday]);
      this.getListPageByMchBody(
        Object.assign(clone(this.formInline), clone(this.pageInfo))
      );
    },
    reset() {
      this.$refs.formInline.resetFields()
      this.init()
    },
    // 导出
    platformMerchantExport() {
      let datas = {
        startDate: this.formInline.timeDate[0] + " 00:00:00",
        endDate: this.formInline.timeDate[1] + " 23:59:59",
        ...this.formInline
      };
      delete datas.timeDate
      this.$refs.FileExport.init(
        datas,
        "jsw-order-provider",
        "/adm/wxZfbBill/downloadExcelByMchBody",
        1,
        "平台商品对账单.xlsx"
      );
    },
    // 账单日期选择
    timeDateChange(payload) {
      this.$set(this.formInline, "timeDate", payload);
      this.getListPageByMchBody(
        Object.assign(clone(this.formInline), {
          page: 1,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 请求列表数据
    getListPageByMchBody(payload) {
      delete payload.total;
      this.loading = true;
      this.$set(this.pageInfo, "page", payload.page);
      this.$set(this.pageInfo, "limit", payload.limit);
      payload.startDate = payload.timeDate[0] + " 00:00:00";
      payload.endDate = payload.timeDate[1] + " 23:59:59";
      delete payload.timeDate;
      getListPageByMchBody(payload)
        .then((res) => {
          if (res.code === 0) {
            this.data = res.data.records || [];
            this.pageInfo.total = Number(res.data.total) || 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getListPageByMchBody(
        Object.assign(clone(this.formInline), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getListPageByMchBody(
        Object.assign(clone(this.formInline), { page: 1, limit: payload })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.platformMerchant_Box {
  margin-top: 26px;
  .platformMerchant_Head {
    .head_Box {
      margin-left: 50px;
    }
    ::v-deep .el-range-separator {
      width: 50px;
    }
  }
}
</style>